import { filter } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { AuthService } from '../services/auth.service';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

export function authenticationGuard(): CanActivateFn {
    return () => {
        const authService: AuthService = inject(AuthService);

        return toObservable(authService.isAuthenticated).pipe(filter(isAuthenticated => isAuthenticated));
    };
}
